import { I18nComponente } from "@/types/gerais"

export const ODadosGrupoi18n: I18nComponente = {
  "pt-BR": {
    nomeDoGrupo: "nome do grupo",
    usuariosResponsaveis: "usuários responsáveis",
    campoObrigatorio: "campo obrigatório",
  },
  "es-CO": {
    nomeDoGrupo: "nombre del grupo",
    usuariosResponsaveis: "usuarios responsables",
  }
}
